<template>
  <v-row>
    <v-col>
      <v-sheet 
        width="100%"
        outlined>
        <v-row>
          <v-col 
            cols="12" 
            xl="6" 
            md="6" 
            sm="12" 
            class="pa-8">
            <v-btn 
              @click="addCountry"
              color="primary">
              Nuevo Pais
            </v-btn>
          </v-col>

          <v-col 
            cols="12" 
            xl="6" 
            md="6" 
            sm="12" 
            class="pa-8">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="countries"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50],
                'items-per-page-text':'Filas por página'
              }"
              :items-per-page="30"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="primary"
                      @click="show(item.id)"
                    >
                      <v-icon dark small>
                        mdi-eye
                      </v-icon>
                    </v-btn>

                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="warning"
                      @click="edit(item.id)"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>

                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="red"
                      @click="confirmDelete(item.id)"
                    >
                      <v-icon dark small>
                        mdi-close
                      </v-icon>
                    </v-btn>
              </template>
            </v-data-table>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="dialog_loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="dialog_new"
      width="700"
    >
      <v-card>
        <v-card-title class="text-h5">
          Nuevo país
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" xl="8" md="8 sm=12">
              <v-text-field
                v-model="name"
                outlined
                label="Nombre país">
              </v-text-field>
            </v-col>
            <v-col cols="12" xl="4" md="4 sm=12">
              <v-text-field
                v-model="short_name"
                outlined
                label="Nombre corto">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-file-input
                outlined
                v-model="flag"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-image"
                label="Bandera/logo"
              ></v-file-input>
            </v-col>
          </v-row>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_new=false"
            :disabled="btn_loading"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="name==''||short_name==''||flag==null"
            text
            :loading="btn_loading"
            @click="createCountry()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_edit"
      width="700"
    >
      <v-card>
        <v-card-title class="text-h5">
          Editar país
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" xl="8" md="8 sm=12">
              <v-text-field
                v-model="name"
                outlined
                label="Nombre país">
              </v-text-field>
            </v-col>
            <v-col cols="12" xl="4" md="4 sm=12">
              <v-text-field
                v-model="short_name"
                outlined
                label="Nombre corto">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-file-input
                outlined
                v-if="!flag"
                v-model="flag"
                :rules="rules"
                @change="onFlagChange"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Bandera/logo"
                :messages="['Para una mejor visualización, usar un foto cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
              ></v-file-input>

              <v-card
                v-if="flag"
                wei>
                <v-img
                  contain
                  :src="url_flag"
                  height="180px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteFlag()">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card> 

            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_loading"
            @click="dialog_edit=false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="name==''||short_name==''||flag==null"
            text
            :loading="btn_loading"
            @click="updateAcademicUnit()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_show"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          País
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="6">
              <v-img
                v-bind:src="url_flag"
                max-height="110px"
                min-height="110px"
                contain
              >
              </v-img>
            </v-col>
            <v-col cols="6">
              <label class="subtitle-2 black--text">País:</label>
              <p class="subtitle-1">{{country.name }}</p>

              <label class="subtitle-2 black--text">Nombre corto:</label>
              <p class="subtitle-1">{{country.short_name }}</p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_show=false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar este país?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_loading"
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="btn_loading"
            @click="deleteCountry"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'AcademicUnits',

    data: () => ({
      btn_loading:false,
      dialog_loading:true,
      dialog_new:false,
      dialog_edit:false,
      dialog_show:false,
      dialog_delete:false,
      delete_id:null,

      id:null,
      name:'',
      short_name:'',
      flag:null,
      country:[],
      url_flag:'',
      countries:[],
      academic_unit:[],

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      search: '',
      headers: [
        {
          text: 'ID',
          align: 'center',
          filterable: false,
          value: 'id',
          width: '10%'
        },
        {
          text: 'País',
          align: 'start',
          filterable: true,
          value: 'name',
          width: '40%'
        },
        {
          text: 'Nombre corto',
          align: 'center',
          filterable: true,
          value: 'short_name',
          width: '20%'
        },
        {
          text: 'Acciones',
          align: 'center',
          filterable: false,
          value: 'actions',
          width: '30%'
        },
      ]
    }),
    methods:{
      async getCountries()
      {
        await axios.get('admin/countries').then(response =>{
          this.countries = response.data.data.countries
          this.dialog_loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      addCountry(){
        this.name=''
        this.short_name=''
        this.flag=null
        this.dialog_new=true
      },

      async createCountry()
      {
        this.btn_loading = true

        let formData= new FormData()
        formData.append('name', this.name)
        formData.append('short_name', this.short_name)
        formData.append('flag', this.flag)

        try {
          await axios({
            method: 'post',
            url: 'admin/countries',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.getCountries()
            this.dialog_new=false
            this.btn_loading = false
          })
        } catch (error) {
          this.dialog_new = false
          this.btn_loading = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      async show(id)
      {
        this.dialog_loading=true
        try {
          await axios.get('admin/countries/'+id).then(response =>{
            this.country = response.data.data.country
            this.url_flag = APP_URL + this.country.flag
            this.dialog_loading=false
            this.dialog_show=true
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      },

      async edit(id){
        this.id=id
        this.dialog_loading= true
        try {
          await axios.get('admin/countries/'+id).then(response =>{
            this.country = response.data.data.country

            this.name=this.country.name
            this.short_name=this.country.short_name
            this.flag=this.country.flag
            this.url_flag = APP_URL + this.country.flag

            this.dialog_loading=false
            this.dialog_edit=true
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      },

      async updateAcademicUnit(){
        this.btn_loading = true

        let formData= new FormData()
        formData.append('id', this.id)
        formData.append('name', this.name)
        formData.append('short_name', this.short_name)
        formData.append('flag', this.flag)

        try {
          await axios({
            method: 'post',
            url: 'admin/countries/'+this.id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.getCountries()
            this.id=null
            this.dialog_edit=false
            this.btn_loading = false
          })
        } catch (error) {
          this.dialog_new = false
          this.btn_loading = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onFlagChange(){
        this.url_flag = URL.createObjectURL(this.flag);
      },

      deleteFlag(){
        this.flag=null
        this.url_flag=null
      },

      confirmDelete(id){
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteCountry(){
        this.btn_loading=true
        try {
          await axios.delete('admin/countries/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.delete_id = null
            this.dialog_loading=true
            this.btn_loading=false
            this.getCountries()
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      }

    },

    created(){
      this.getCountries()
    },
  }
</script>